import React from 'react';
import { PackageCheckIcon } from 'lucide-react';
interface OrderItem {
  id: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
}
interface NowOrderItemsSummaryProps {
  items: OrderItem[];
  compact?: boolean;
}
export function NowOrderItemsSummary({
  items,
  compact = false
}: NowOrderItemsSummaryProps) {
  return <section className="overflow-hidden rounded-xl border border-brand-border bg-white" aria-label="NOW order summary" data-id="element-1600" data-mp="2rsayr18m76jm">
      <header className="flex items-center justify-between gap-3 bg-brand px-3 py-2.5 text-white" data-id="element-1601" data-mp="1v56b0zfe3uuz">
        <span className="text-xs font-bold" data-id="element-1602" data-mp="203rct3aaimlj">One NOW order</span>
        <span className="flex items-center gap-1 text-[10px] font-bold" data-id="element-1603" data-mp="242qbi65fhn4j"><PackageCheckIcon className="h-3.5 w-3.5" data-id="element-1604" data-mp="2934cx5cixytl" /> All items together</span>
      </header>
      <div className={compact ? 'space-y-3 p-3' : 'space-y-3 p-4'} data-id="element-1605" data-mp="3fix58o2z0iri">
        {items.map(item => <article key={item.id} className="flex gap-3 border-b border-gray-100 pb-3 last:border-b-0 last:pb-0" data-id="element-1606" data-mp="3khhz85rmq67i">
            <img src={item.image} alt={item.name} className={`${compact ? 'h-14 w-14' : 'h-16 w-16'} shrink-0 rounded-lg bg-gray-50 object-cover`} data-id="element-1607" data-mp="2cidl22cj5otn" />
            <div className="min-w-0 flex-1" data-id="element-1608" data-mp="27gxz882j3ea7"><h3 className={`${compact ? 'text-xs' : 'text-sm'} line-clamp-2 font-medium text-gray-900`} data-id="element-1609" data-mp="22jo3kaojq6dx">{item.name}</h3><div className="mt-1 flex items-center justify-between gap-3" data-id="element-1610" data-mp="1xlcrdtas3jsj"><span className="text-xs text-gray-600" data-id="element-1611" data-mp="1xmxljht6l0pv">× {item.quantity}</span><span className="shrink-0 text-sm font-bold text-gray-900" data-id="element-1612" data-mp="1tkaz5wfa4802">SAR {item.price.toFixed(2)}</span></div></div>
          </article>)}
      </div>
    </section>;
}